import { createOption, FilterSidebarLayout, useBreadcrumbs } from '@mews-commander/ui';
import { primitiveTypeUniq } from '@mews/fp';
import { lt } from '@mews/framework';
import { useTableState } from '@optimus-web/core';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useLibraryTabs } from '../components/common/hooks/useLibraryTabs';
import { useGetServiceNamesByIdQuery } from '../components/common/queries/useGetServiceNamesByIdQuery';
import { useFilteredTemplatesTableData } from '../components/externalTemplates/templatesTable/hooks/useFilterTemplatesTableData';
import { TemplatesTable } from '../components/externalTemplates/templatesTable/TemplatesTable';
import {
    templatesTableFilterSchema,
    TemplatesTableFiltersForm,
    TemplatesTableFilterValues,
} from '../components/externalTemplates/templatesTable/TemplatesTableFilters';
import { TemplatesTableRowData } from '../components/externalTemplates/templatesTable/types';

const DEFAULT_FILTER_VALUES = { name: '', service: [], status: [] };

export const ExternalTemplates = ({ searchParams }: { searchParams: TemplatesTableFilterValues }) => {
    const [tableState, setTableState] = useTableState<TemplatesTableRowData>({
        pagination: { show: false },
    });
    const breadcrumbs = useBreadcrumbs();
    const tabs = useLibraryTabs();

    const { data: contractTemplatesData } = useRepositorySuspenseQuery('reservationContractTemplates', 'getAll', {});
    const serviceIds = primitiveTypeUniq(
        contractTemplatesData.templates?.flatMap((template) => template.services.map((s) => s.id)) ?? []
    );
    const { data: serviceNamesById } = useGetServiceNamesByIdQuery();

    const serviceOptions = serviceIds.map((id) =>
        createOption({
            value: id,
            label: serviceNamesById[id],
        })
    );
    const filteredTableData = useFilteredTemplatesTableData({
        filters: searchParams,
        tableSearchValue: tableState.globalFilters.search,
        serviceNamesById,
    });
    return (
        <FilterSidebarLayout
            breadcrumbs={breadcrumbs}
            tabs={tabs}
            filterSchema={templatesTableFilterSchema}
            filterSidebar={{
                title: lt('Filter'),
                fields: <TemplatesTableFiltersForm serviceOptions={serviceOptions} />,
            }}
            defaultFilterValues={DEFAULT_FILTER_VALUES}
            filterSidebarOpenedByDefault={false}
            submitButtonLabel={lt('ApplyFilters')}
            withClearFilters
        >
            <TemplatesTable
                data={filteredTableData}
                loading={false}
                tableState={tableState}
                onTableStateChange={setTableState}
            />
        </FilterSidebarLayout>
    );
};
